import React from 'react';
import { Snackbar,Alert } from '@mui/material';
import { connect } from 'react-redux';
import { getActions } from '../../store/actions/alertActions';


const AlertNotification = ({
    showAlertMessage,
    closeAlertMessage,
    alertMessageContent,
}) => {
    return (
        <Snackbar anchorOrigin={{vertical:'bottom', horizontal:'center'}}
        open={showAlertMessage}
        autoHideDuration={2000}
        onClose={closeAlertMessage}
        >
            <Alert severity='info'>{alertMessageContent}</Alert>
        </Snackbar>
    );
};

const mapStoreStateToProps =({alert})=>{
    return{
        ...alert,
    };
};

const mapActionsToProps =(dispatch) =>{
    return {
        ...getActions(dispatch),
    };
};

export default connect(mapStoreStateToProps,mapActionsToProps)(AlertNotification);